/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


// $(document).mouseup(function (e) {
//   var popup = $(".main_popup");
//   if (!$('body').is(e.target) && !popup.is(e.target) && popup.has(e.target).length == 0) {
//     popup.slideUp(1000);
//     set_cookie();
//   }
// });
$(document).ready(function(){
//   $('.thishascurrent').hover(function(){
//     var tabbing_id = $(this).attr('data-submenu');

//     $('.thishascurrent ').removeClass('currentactive');
//     $('.Header__MainNav').removeClass('currentactive');

//     $(this).addClass('currentactive');
//     $(".bottom_main_menu nav.Header__MainNav."+tabbing_id).addClass('currentactive');
//   });
  $( "#section-header" ).mouseleave(function() {
    $('.thishascurrent').removeClass('currentactive');
    $('.Header__MainNav').removeClass('currentactive');
    $('.thishascurrent.default-active').addClass('currentactive');
    $('.Header__MainNav.default-active').addClass('currentactive');
  });
  

  if($(window).width() < 1140){
    
    $('body').on('click','#mobilesidebar',function(e){
      e.preventDefault();
      var html = $('.bottom_menu.mobile').html();
      $('.Drawer__Main nav.SidebarMenu__Nav.SidebarMenu__Nav--primary').html(html);
      $('.SidebarMenu__Nav .mobileparent.now-active-parent').parent().find('.mobilemegamain nav.Header__MainNav').removeClass('hidden-pocket hidden-lap');
    });

    $('body').on('click','.Drawer__Main .HorizontalList__Item.mobilesidenew a.mobileparent',function(e){
      e.preventDefault();

      if($(this).parent().find('.mobilemegamain nav.Header__MainNav').hasClass('hidden-pocket')){
        $('.mobilesidenew').find('.mobilemegamain nav.Header__MainNav').addClass('hidden-pocket hidden-lap');
        $('.Drawer__Main .HorizontalList__Item.mobilesidenew a.mobileparent').removeClass('now-active-parent');
        $(this).addClass('now-active-parent');
        $(this).parent().find('.mobilemegamain nav.Header__MainNav').removeClass('hidden-pocket hidden-lap');
      }else{
        $('.Drawer__Main .HorizontalList__Item.mobilesidenew a.mobileparent').removeClass('now-active-parent');
        $('.mobilesidenew').find('.mobilemegamain nav.Header__MainNav').addClass('hidden-pocket hidden-lap');
        $(this).removeClass('now-active-parent');
      }

    });
    $('body').on('click','.Drawer__Main .mobilemegamain a.menusubparent',function(e){
      e.preventDefault();
      if($(this).hasClass('submenu-default')){
      if($(this).parent().find('.DropdownMenu').hasClass('mobactive-mega')){
        $('.Drawer__Main .mobilemegamain a.subparentMega').removeClass('now-active-subparent');
        $('.mobilemegamain a.subparentMega').parent().find('.mega_menu').removeClass('mobactive-mega');
        $(this).removeClass('now-active-subparent');
        $(this).parent().find('.DropdownMenu').removeClass('mobactive-mega');
      }else{
        $('.Drawer__Main .mobilemegamain a.subparentMega').removeClass('now-active-subparent');
        $('.mobilemegamain a.subparentMega').parent().find('.mega_menu').removeClass('mobactive-mega');
        $(this).addClass('now-active-subparent');
        console.log('if');
        
        $(this).parent().find('.DropdownMenu').addClass('mobactive-mega');
        $(this).closest('.HorizontalList__Item')[0].scrollIntoView();
      }
      }else{
      if($(this).parent().find('.mega_menu').hasClass('mobactive-mega')){
        $('.Drawer__Main .mobilemegamain a.subparentMega').removeClass('now-active-subparent');
        $('.mobilemegamain a.subparentMega').parent().find('.mega_menu').removeClass('mobactive-mega');
        $('.mobilemegamain a.subparentMega').parent().find('.DropdownMenu').removeClass('mobactive-mega');
        $(this).removeClass('now-active-subparent');
        $(this).parent().find('.mega_menu').removeClass('mobactive-mega');
      }else{
        $('.Drawer__Main .mobilemegamain a.subparentMega').removeClass('now-active-subparent');
        $('.mobilemegamain a.subparentMega').parent().find('.DropdownMenu').removeClass('mobactive-mega');
        $('.mobilemegamain a.subparentMega').parent().find('.mega_menu').removeClass('mobactive-mega');
        $(this).addClass('now-active-subparent');
        $(this).parent().find('.mega_menu').addClass('mobactive-mega');
        
        $(this).closest('.HorizontalList__Item')[0].scrollIntoView(); 
      }
      }
    });
    
  }
  
});